import React from "react";
import { useNavigate } from "react-router-dom";

const DeleteSuccessPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-100 px-4 py-6 flex flex-col items-center">

      {/* 🔹 Breadcrumb */}
      <div className="w-full max-w-5xl mb-6 text-xs">
        <span className="text-neutral-400">Home / </span>
        <span className="text-black">Request Accepted</span>
      </div>

      {/* 🔹 Card */}
      <div className="w-full max-w-2xl bg-white rounded-2xl shadow-lg border border-black/10 p-8 flex flex-col items-center text-center">

        {/* 🔹 Success Icon */}
        <div className="w-20 h-20 sm:w-24 sm:h-24 bg-emerald-500 rounded-full flex items-center justify-center mb-6">
          <svg
            className="w-10 h-10 sm:w-12 sm:h-12 text-white"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M5 13l4 4L19 7"
            />
          </svg>
        </div>

        {/* 🔹 Title */}
        <h2 className="text-xl sm:text-3xl font-semibold text-black mb-4">
          Account Deletion Request Accepted
        </h2>

        {/* 🔹 Description */}
        <p className="text-sm sm:text-lg text-stone-500 leading-relaxed mb-8 max-w-xl">
          Your request has been accepted. For security and data processing, it
          may take up to <span className="font-semibold">90 days</span> to
          completely remove your data from our servers. During this period, you
          will not be able to log in.
        </p>

        {/* 🔹 Button */}
        <button
          onClick={() => navigate("/")}
          className="w-full sm:w-80 h-12 bg-green-700 text-white rounded-lg font-semibold hover:bg-green-800 transition"
        >
          Go Back to Home
        </button>
      </div>
    </div>
  );
};

export default DeleteSuccessPage;